import { useState } from "react";
import { focusTabs, focusCards } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function FocusSection() {
  const [active, setActive] = useState(focusTabs[0].name);
  const current = focusTabs.find((t) => t.name === active)!;
  const cards = focusCards[active] ?? [];

  return (
    <section id="focus" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <SectionHeading eyebrow="焦点专区" title="按分类逛热点，只看感兴趣的" sub="娱乐影视、社会民生、科技财经、体育竞技、网络热议，五种视角任你切换。" />
        </div>

        {/* 分类切换 */}
        <div className="mt-7 flex max-w-full gap-2 overflow-x-auto pb-1">
          {focusTabs.map((t) => (
            <button
              key={t.name}
              type="button"
              onClick={() => setActive(t.name)}
              className={`flex shrink-0 items-center gap-2 rounded-full px-4 py-2 text-sm font-bold whitespace-nowrap transition-colors ${
                active === t.name ? "bg-accent-500 text-background-50" : "bg-background-100 text-foreground-700 hover:bg-secondary-100"
              }`}
            >
              <i className={`text-base ${t.icon}`}></i>
              {t.name}
              <span className={`rounded-full px-1.5 text-xs ${active === t.name ? "bg-background-50/20" : "bg-background-200 text-foreground-500"}`}>
                {t.count.replace("今日 ", "").replace(" 条", "")}
              </span>
            </button>
          ))}
        </div>

        {/* 当前分类说明 */}
        <div className="mt-5 flex flex-col gap-4 rounded-2xl border border-accent-200 bg-accent-50 p-5 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-accent-500 text-xl text-background-50">
              <i className={current.icon}></i>
            </span>
            <div>
              <h3 className="font-heading text-xl font-bold text-accent-900">{current.name}</h3>
              <p className="text-sm text-accent-800/80">{current.desc}</p>
            </div>
          </div>
          <span className="inline-flex shrink-0 items-center gap-2 rounded-full bg-background-50 px-3 py-1.5 text-xs font-bold text-accent-700 whitespace-nowrap">
            {current.count} · 持续更新中
          </span>
        </div>

        {/* 卡片流 */}
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {cards.map((c, i) => (
            <article
              key={c.title}
              className="group flex flex-col rounded-xl border border-background-200 bg-background-100/60 p-4 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <div className="flex items-center gap-2">
                <span className={`rounded-md px-2 py-0.5 text-xs font-bold text-background-50 ${i % 2 === 0 ? "bg-primary-500" : "bg-secondary-500"}`}>{c.tag}</span>
                <span className="ml-auto text-xs text-foreground-500">{c.time}</span>
              </div>
              <h3 className="mt-3 line-clamp-2 text-[15px] font-semibold leading-snug text-foreground-950">{c.title}</h3>
              <div className="mt-auto flex items-center gap-2 pt-4">
                <span className="inline-flex items-center gap-1 text-xs font-bold text-primary-700">
                  <i className="ri-fire-fill"></i>
                  {c.heat}
                </span>
                <button
                  type="button"
                  onClick={() => document.getElementById("buzz")?.scrollIntoView({ behavior: "smooth" })}
                  className="ml-auto flex items-center gap-1 text-xs font-bold text-foreground-600 opacity-0 transition-opacity group-hover:opacity-100"
                >
                  看详情
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}